<script>
import VuetifyColourClass from '@/constants/core/VuetifyColourClass'
import { FormSubmissionState } from '@/constants/form/FormSubmissionState'
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'FormSubmissionStateLabel',
  mixins: [baseMixin],
  props: {
    state: {
      type: String,
      required: true,
      validator: function (value) {
        return Object.values(FormSubmissionState).includes(value)
      },
    },
  },
  computed: {
    compStateText() {
      switch (this.state) {
        case FormSubmissionState.Draft:
          return 'Draft'
        case FormSubmissionState.Submitted:
          return 'Submitted'
        default:
          return 'Unknown'
      }
    },
    compStateColour() {
      switch (this.state) {
        case FormSubmissionState.Draft:
          return VuetifyColourClass.warning
        case FormSubmissionState.Submitted:
          return VuetifyColourClass.success
        default:
          return VuetifyColourClass.grey
      }
    },
  },
  methods: {},
}
</script>

<template>
  <v-chip class="ml-2" small color="#F5F5F5">
    <v-badge :color="compStateColour" dot inline left class="ml-n1">
      <span class="ml-1">{{ compStateText }}</span>
    </v-badge>
  </v-chip>
</template>
